import React from "react";
import { Helmet } from "react-helmet-async";
import { buildCanonical, SITE_URL } from "../hooks/useSEO";

// Reusable SEO component with OpenGraph, Twitter, canonical + hreflang + JSON-LD
const Seo = ({
  title,
  description,
  path = "/",
  lang = "tr",
  image = "https://adalcrea.com/assets/adalcrea-logo.png",
  type = "website",
  jsonLd,
  noindex = false,
}) => {
  const canonical = buildCanonical(path);
  const fullTitle = title ? `${title} | AdalCrea` : "AdalCrea | Kurumsal IT Çözümleri & Dijital Dönüşüm Ajansı";
  return (
    <Helmet htmlAttributes={{ lang }}>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow"} />
      {!noindex && <link rel="canonical" href={canonical} />}
      {!noindex && <link rel="alternate" hrefLang="tr" href={canonical} />}
      {!noindex && <link rel="alternate" hrefLang="en" href={canonical} />}
      {!noindex && <link rel="alternate" hrefLang="x-default" href={canonical} />}

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="AdalCrea" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content={lang === "tr" ? "tr_TR" : "en_US"} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export const ORG_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "AdalCrea",
  url: SITE_URL,
  logo: "https://adalcrea.com/assets/adalcrea-logo.png",
  description:
    "İşletmelerin dijital dönüşüm süreçlerine öncülük eden, yenilikçi ve güvenilir bir IT teknoloji firması.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Zuhuratbaba Mah. Tatlınar Sokak No 2",
    addressLocality: "Bakırköy",
    addressRegion: "İstanbul",
    addressCountry: "TR",
  },
  telephone: "+90 543 804 70 05",
  email: "info@adalcrea.com.tr",
  sameAs: [],
};

export default Seo;
